import AxiosClient from '../../../services/axios.services';

class DashboardSelecRespServices {
  getDashboarSelecResp = params => AxiosClient.get('/api/app/seleccion_contratacion_dashboard_contrataciones/', {
    headers: {'Content-Type': 'application/json'},
    params: params
  });
}

export default new DashboardSelecRespServices();

//seleccion_contratacion_dashboard_motivo_solicitud
//seleccion_contratacion_dashboard_contrataciones
//seleccion_contratacion_dashboard_vacantes